import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { media } from '../../utils/rwd';

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000000;
  width: 100%;
  height: 80px;
  padding: 10px 20px;
  box-sizing: border-box;
  z-index: 9999;

  ${media.sm.down`
    flex-direction: column;
    padding: 15px;
    gap: 10px;
  `}
`;

export const Logo = styled.img<{ size: number }>`
  max-height: ${({ size }) => size}px;
`;

export const Disclaimer = styled.div`
  color: white;
  font-size: 12px;
  line-height: 15px;
  text-align: center;

  ${media.xl.down`
    display: none;
    `}
`;

export const LinksRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: center;

  ${media.sm.down`
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    display: flex;
  `}
`;

export const Divider = styled.div`
  background: #ffffff;
  width: 1px;
  height: 14px;
  display: block;
  ${media.sm.down`
    display: none;
  `}
`;

const LinkStyle = `
  text-decoration: none;
  color: #ffffff;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0;
  text-transform: uppercase;
  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }

`;

export const PageLink = styled(Link)`
  ${LinkStyle}
`;

export const ExternalLink = styled.a`
  ${LinkStyle}
`;

export const LanguagePicker = styled(Dropdown)`
  margin-top: 35px;

  .show > .btn-primary.dropdown-toggle {
    background: inheirt;
    border: none;
    box-shadow: none;
  }

  .dropdown-toggle {
    background: inherit;
    border: none;
  }

  ${media.sm.down`
    margin-top: 10px;
  `}
`;
